export const formatSecondsToHHMMSS = (seconds) =>
  new Date(seconds * 1000).toISOString().substring(11, 19);
